import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        Home Lead IQ values your privacy. This Privacy Policy explains how we collect, use, and protect your information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p>
        We collect personal data such as your name, email, phone number, and any lead information you submit. We also track usage data to improve performance.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <p>
        We use your data to provide lead management services, automate follow-ups, schedule calls, and sync with your calendar. We do not sell or share your data with third parties.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Security</h2>
      <p>
        Your data is encrypted and stored securely. We use industry-standard practices to protect your information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Your Rights</h2>
      <p>
        You can request access to, modification of, or deletion of your data at any time by contacting us at support@homeleadiq.com.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Updates</h2>
      <p>
        This policy may be updated from time to time. We’ll notify users of significant changes via email or platform notification.
      </p>

      <p className="mt-6">Effective date: May 29, 2025</p>
    </div>
  );
}

export default PrivacyPolicy;